import React from "react";
import { formatCurrency } from "../../lib/utils";

function Row({ label, value, muted, accent, testId }) {
  return (
    <div className="flex items-center justify-between">
      <span className={muted ? "text-text-muted" : "text-text-main"}>{label}</span>
      <span
        className={accent ? "font-medium text-accent-hover" : muted ? "text-text-muted" : "text-text-main"}
        data-testid={testId}
      >
        {value}
      </span>
    </div>
  );
}

// Full Initial → Discount → Subtotal → GST → Amount to Receive block.
export function GstBreakdown({ bd, testId = "gst-breakdown", className = "", totalLabel = "Amount to receive" }) {
  if (!bd) return null;
  return (
    <div className={`space-y-1.5 text-sm ${className}`} data-testid={testId}>
      {bd.hasDiscount && (
        <>
          <Row label="Initial amount" value={formatCurrency(bd.initial)} muted testId={`${testId}-initial`} />
          <Row label="Discount" value={`− ${formatCurrency(bd.discount)}`} accent testId={`${testId}-discount`} />
        </>
      )}
      <Row label="Subtotal" value={formatCurrency(bd.subtotal)} muted testId={`${testId}-subtotal`} />
      {bd.enabled && (
        <Row label={`${bd.label} (${bd.rate}%)`} value={`+ ${formatCurrency(bd.gst)}`} muted testId={`${testId}-gst`} />
      )}
      <div className="flex items-center justify-between border-t border-border pt-1.5">
        <span className="font-semibold text-text-main">{totalLabel}</span>
        <span className="font-heading text-lg font-bold text-text-main" data-testid={`${testId}-total`}>
          {formatCurrency(bd.total)}
        </span>
      </div>
    </div>
  );
}

// Compact one-liner: total with an "(incl. $x GST)" hint.
export function GstInline({ bd, testId = "gst-inline", className = "" }) {
  if (!bd) return null;
  return (
    <span className={className} data-testid={testId}>
      <span className="font-medium text-text-main">{formatCurrency(bd.total)}</span>
      {bd.enabled && bd.gst > 0 && (
        <span className="ml-1 text-xs text-text-muted">(incl. {formatCurrency(bd.gst)} GST)</span>
      )}
    </span>
  );
}
